import * as React from 'react'

import { NotificationContextType, useNotification } from './hooks'

export function withNotificationContext<T extends NotificationContextType = NotificationContextType>(
  WrappedComponent: React.ComponentType<T>
) {
  const displayName = WrappedComponent.displayName ?? WrappedComponent.name ?? 'Component'
  const WithNotificationContext = (props: Omit<T, keyof NotificationContextType>) => {
    const notification = useNotification()
    return <WrappedComponent notificationContext={notification} {...(props as T)} />
  }

  WithNotificationContext.displayName = `withNotificationContext(${displayName})`

  return WithNotificationContext
}
